var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCertificate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 97,
    viewBox: "0 0 177 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M138.68 43.9297V62.8097C138.68 62.8097 130.04 79.1197 88.6799 79.1197C47.3199 79.1197 36.4299 62.8097 36.4299 62.8097V43.9297",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 33.51L88.23 59.75L174.96 33.51L175.02 28.74L88.23 1.5L1.54 28.63L1.5 33.51Z",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M175.02 28.7409L88.26 54.5309L1.54004 28.6309",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M95.29 24.2109L148.05 36.3909V65.7209",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6799 23.25C80.6799 24.37 84.0899 25.25 88.2899 25.25C92.4899 25.25 95.89 24.34 95.89 23.25C95.89 22.16 92.4899 21.25 88.2899 21.25C84.0899 21.25 80.6799 22.13 80.6799 23.25Z",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M155.51 94.8006C155.51 87.8506 156.65 74.8906 148.51 74.8906C140.37 74.8906 141.51 87.8906 141.51 94.8006H155.51Z",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M152.51 68.84C152.091 67.8433 151.318 67.0377 150.339 66.5794C149.36 66.121 148.245 66.0426 147.212 66.3595C146.179 66.6763 145.3 67.3657 144.746 68.294C144.192 69.2222 144.003 70.3231 144.215 71.383C144.427 72.443 145.025 73.3864 145.893 74.0302C146.761 74.6741 147.838 74.9724 148.914 74.8674C149.989 74.7623 150.988 74.2614 151.715 73.4618C152.442 72.6622 152.847 71.6209 152.85 70.54C152.851 69.9563 152.736 69.3783 152.51 68.84",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M88.26 54.5293V59.7493",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificate);
export default __webpack_public_path__ + "static/media/certificate.348f3433.svg";
export { ForwardRef as ReactComponent };